import { styled, css } from 'styled-components';
import { animationDuration, drawerBottomBuffer } from '../drawerConsts';
import { dontForwardProps } from '../../../util';
export const DrawerContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-msahrv-0"
})(["display:flex;flex-direction:column;align-items:center;width:100%;", " z-index:1000;position:absolute;left:0;transition-duration:", ";transition-timing-function:ease-in-out;", " will-change:transform;"], ({
  $stickyAction
}) => $stickyAction ? css(["max-height:calc(90% + ", ");bottom:-", ";"], drawerBottomBuffer.sticky, drawerBottomBuffer.sticky) : css(["max-height:140vh;bottom:-", ";"], drawerBottomBuffer.default), animationDuration, ({
  isOpen
}) => css(["transform:translateY(", ");visibility:", ";"], isOpen ? '0' : '100%', isOpen ? 'visible' : 'hidden'));